import * as React from 'react';
import {useState, useEffect} from 'react';
import Animation from './animation';
import AnimationBuoy from './animation_buoy';
import AnimationCar from './animation_car';
import AnimationDrone from './animation_dokuro';
import AnimationCamera from './animation_camera';
import { isAthlete, isCamera } from '../../initialize/device_helpers';

const SIZE = 20;

var upd_time =  new Date();

// Important for perf: the markers never change, avoid rerender when the map viewport changes
function Sups(props) {
  const {devices} = props;

  const [animate_flg, setAnimateFlg] = useState(false);

  // マーカー移動の制御
  // 1秒以内の更新は移動しない -> 処理が重くなるため
  // main内、setIntervalの仕様変更により、短時間に複数回呼ばれることがあるため
  useEffect(() => {
		if(new Date() - upd_time < 1000){
			setAnimateFlg(false);
			return null;
		}
		//console.log(new Date() - upd_time);
		upd_time = new Date();
		setAnimateFlg(true);
	},[devices]);


  if(!devices)
    return null;


  const sups = [];
  devices.forEach((device, i)=>{
      sups.push(<Animation
                  key={device.id}
                  id={device.id}
                  name={device.disp_name}
                  focus={device.ischecked}
                  showMarker={device.showMarker}
                  bearing={0}
                  speed={device.speed}
                  time={device.time}
                  color={device.color}
                  position={{lat:device.lat, lon:device.lon, angle: device.angle}}
                  animate_flg={animate_flg}
                  category={device.category}
                  />);
  });
  return sups;
}

export default React.memo(Sups);
